// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2kltg","inner":"Form_inner__3KRgH","range":"Form_range__RnLdN","name":"Form_name__1RT8a","actions":"Form_actions__2aB6u"};